import React, { useState, useEffect, useCallback } from "react";
import { getParticipatorAnswerApi } from "../../../services/QuizService";
import DataLoader from "../Dashboard/Loader";
const ParticipatonAnswers = ({ participantId, isShowTwoPerRow=false }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(() => {
    setIsLoading(true);
    getParticipatorAnswerApi(participantId)
      .then((resp) => {
        setData(resp.data.results);
      })
      .catch((error) => {
        console.error(error.response?.data?.message || "Error fetching data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const DisplayQuestionOption = ({
    optionText,
    isCorrectOption,
    isSelectedOption,
    optionChar,
  }) => {
    let liClassName = "list-group-item";

      if (isSelectedOption) {
        liClassName = "list-group-item text-white bg-danger"
        if(isCorrectOption){
          liClassName = "list-group-item text-white bg-success";
        }
      } else if (isCorrectOption) {
        liClassName = "list-group-item text-white  bg-light-success";
      }
    return (
      <li className={liClassName}>
        {optionChar}. {optionText}
      </li>
    );
  };

  return (
    <div className="card-body p-0">
      <tbody>
        {isLoading ? (
          <DataLoader />
        ) : data?.length ? (
          <div className="row">
            {data.map((answer) => (
              <div
                key={answer.id}
                className={`mb-2 ${isShowTwoPerRow ? "col-lg-6" : "col-lg-4"}`}
              >
                <div className="card card-body">
                  <h4 className="text-primary">
                    Question {answer.question.question_number}:
                  </h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: answer.question.question_text,
                    }}
                  ></div>
                  <h4 className="text-black  mb-1">
                    Options:
                  </h4>
                  <ul className="list-group">
                    <DisplayQuestionOption
                      optionText={answer.question.option_1}
                      isCorrectOption={
                        answer.question.correct_option === "option_1"
                      }
                      isSelectedOption={answer.selected_option === "option_1"}
                      optionChar={"A"}
                    />

                    <DisplayQuestionOption
                      optionText={answer.question.option_2}
                      isCorrectOption={
                        answer.question.correct_option === "option_2"
                      }
                      isSelectedOption={answer.selected_option === "option_2"}
                      optionChar={"B"}
                    />
                    <DisplayQuestionOption
                      optionText={answer.question.option_3}
                      isCorrectOption={
                        answer.question.correct_option === "option_3"
                      }
                      isSelectedOption={answer.selected_option === "option_3"}
                      optionChar={"C"}
                    />

                    <DisplayQuestionOption
                      optionText={answer.question.option_4}
                      isCorrectOption={
                        answer.question.correct_option === "option_4"
                      }
                      isSelectedOption={answer.selected_option === "option_4"}
                      optionChar={"D"}
                    />
                  </ul>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-danger">
            ⚠️ No answer available for this quiz.
          </div>
        )}
      </tbody>
    </div>
  );
};

export default ParticipatonAnswers;
